import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.acc.production,
  name: sharedEnvironment.acc.name,
  bpUrl: sharedEnvironment.acc.bpUrl,
  etjansterCommonUrl: sharedEnvironment.acc.etjansterCommonApiUrl,
  cookieDomain: sharedEnvironment.acc.cookieDomain,
  utlysningsbyggareUrl: sharedEnvironment.acc.utlysningsbyggareUrl,
  utlysningsbyggareApiUrl: `${sharedEnvironment.acc.utlysningsbyggareApiUrl}`,
  forhandsgranskaUrl: sharedEnvironment.acc.forhandsgranskaUrl,
  etjansterCommonApiUrl: `${sharedEnvironment.acc.etjansterCommonApiUrl}/api`,
  resourceStringUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring/utlysningsbyggare`,
  sprakHanteringApiUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring`,
  logServiceApiUrl: `${sharedEnvironment.acc.gatewayUrl}/logger`,
  externalLinks: sharedEnvironment.acc.externalLinks,
  baseGatewayUrl: sharedEnvironment.acc.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.acc.apimSubscriptionKey,
  tinyMceApiKey: sharedEnvironment.acc.tinyMceApiKey,
  usePremiumTinyMceFeatures: true,
  etjansterCommonApiScope:
    sharedEnvironment.acc.azureAd.etjansterCommonApiScope,
  featureUrl: `${sharedEnvironment.acc.utlysningsbyggareApiUrl}/feature`,

  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.acc.utlysningsbyggareApiUrl,
      'b51d2eae-c8a0-42b1-8190-3cecb9e91ef5',
      '3466d357-9e57-4347-bddd-a2b9ee6cf44d',
      sharedEnvironment.acc.utlysningsbyggareUrl,
    ),
    allowRedirectInIframe: false,
  },
};
